export enum RecurrentStatesEnumeration {
  IS_RECURRING = 'OLD',
  IS_NEW = 'NEW',
}

export const CUSTOMER_TYPE_CONSTANT = 'Recurrente';
